// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@synd/XDL/types";

export default {
    primary: {
        main: "#E00B5A",
        contrast: "#FFFFFF",
    },
    secondary: {
        main: "#71984A",
        contrast: "#FFFFFF",
    },
    common: {
        background: "#FFFFFF",
        backgroundContrast: "#363636",
        accent: "#F8F9FA",
        accentContrast: "#363636",
        border: "#CCCCCC",
        disabled: "#CCCCCC",
        // XNG-Changes
        ui1: "#FFFFFF",
        ui2: "#EEEEEE",
        ui3: "#CCCCCC",
        ui4: "#999999",
        ui5: "#666666",
        ui6: "#393939",
        ui7: "#231F20",
        ui8: "#F9F8F6",
        ui9: "#577538",
        ui10: "#82AE56",
        ui11: "#425A2B",
        ui12: "#F290B4",
        ui13: "#A60842",
        white: "#FFFFFF",
        black: "#000000",
        brand03: "#E15780",
        brand04: "#415465",
        brand05: "#8D8179",
    },
    text: {
        main: "#393939",
        disabled: "#475353",
        accent: "#FF0000",
        link: "#577538",
    },
    success: {
        main: "#006638",
        light: "#D9F2E7",
        contrast: "#FFFFFF",
    },
    danger: {
        main: "#B10631",
        light: "#FBDBE5",
        contrast: "#FFFFFF",
    },
    warning: {
        main: "#DAA91C",
        light: "#FDF9DE",
        contrast: "#FFFFFF",
    },
    info: {
        main: "#095D8B",
        light: "#DDEEF8",
        contrast: "#FFFFFF",
    },
} as xBaseTheme["colors"];
